// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-overlay {
  position: fixed;
  inset: 0;
  background: rgba(38, 70, 83, 0.85);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.audio-box {
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.1), 
    rgba(255, 255, 255, 0.05)
  );
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  max-width: 480px;
  width: 90%;
  position: relative;
  box-shadow: 
    0 8px 32px 0 rgba(31, 38, 135, 0.37),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  animation: fadeInScale 0.3s ease;
  overflow: hidden;
}

.audio-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    circle at top right,
    rgba(233, 196, 106, 0.15),
    transparent 70%
  );
  z-index: 0;
  pointer-events: none;
}

.audio-box::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    circle at bottom left,
    rgba(42, 157, 143, 0.15),
    transparent 70%
  );
  z-index: 0;
  pointer-events: none;
}

@keyframes fadeInScale {
  0% {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: var(--text-light);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg);
}

.audio-box h2 {
  font-size: 1.8rem;
  color: var(--text-light);
  margin-bottom: 32px;
  font-weight: 600;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.audio-box h2::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, var(--secondary-color), var(--secondary-light));
  border-radius: 3px;
}

.mic-circle {
  width: 90px;
  height: 90px;
  background-color: var(--secondary-color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 16px auto;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.mic-circle:hover {
  background-color: var(--secondary-dark);
  transform: scale(1.05);
}

.mic-circle.recording {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(233, 196, 106, 0.6);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(233, 196, 106, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(233, 196, 106, 0);
  }
}

.mic-icon {
  display: none;
}

.listening .mic-icon {
  color: #ff4b4b;
}

.playing .mic-icon {
  color: #4bff4b;
}

.audio-box p {
  font-size: 1rem;
  color: var(--text-dark);
  margin-bottom: 20px;
}

.status-message {
  color: var(--text-light);
  margin-top: 24px;
  font-size: 1.1rem;
  padding: 12px 24px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: inline-block;
  min-width: 240px;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.status-message[data-status="recording"] {
  background: linear-gradient(to right,
    rgba(233, 196, 106, 0.2),
    rgba(233, 196, 106, 0.1)
  );
  border-left: 3px solid var(--secondary-color);
  animation: glowPulse 2s infinite;
}

.status-message[data-status="transcribing"],
.status-message[data-status="processing"] {
  background: linear-gradient(to right,
    rgba(42, 157, 143, 0.2),
    rgba(42, 157, 143, 0.1)
  );
  border-left: 3px solid var(--primary-color);
  animation: glowPulse 2s infinite;
}

.status-message[data-status="playing"] {
  background: linear-gradient(to right,
    rgba(38, 70, 83, 0.2),
    rgba(38, 70, 83, 0.1)
  );
  border-left: 3px solid var(--text-light);
  animation: glowPulse 2s infinite;
}

@keyframes glowPulse {
  0% {
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
  }
  100% {
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);
  }
}

.submit-btn {
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.submit-btn:hover {
  background-color: #45a049;
}

.submit-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.mic-visualizer {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 auto 32px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  z-index: 1;
  overflow: hidden;
}

.mic-visualizer img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 20px;
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));
}

/* Glow ring indicator */
.mic-visualizer::before {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  background: conic-gradient(
    from 0deg,
    rgba(255, 255, 255, 0.1),
    rgba(233, 196, 106, 0.3),
    rgba(255, 255, 255, 0.1)
  );
  animation: rotate 4s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease;
}

/* Hover state */
.mic-visualizer:hover::before {
  opacity: 1;
}

/* User speaking state */
.mic-visualizer.listening::before {
  opacity: 1;
  background: conic-gradient(
    from 0deg,
    rgba(233, 196, 106, 0.2),
    rgba(233, 196, 106, 0.6),
    rgba(233, 196, 106, 0.2)
  );
  animation: rotate 2s linear infinite;
}

/* Assistant speaking state */
.mic-visualizer.playing::before {
  opacity: 1;
  background: conic-gradient(
    from 0deg,
    rgba(42, 157, 143, 0.2),
    rgba(42, 157, 143, 0.6),
    rgba(42, 157, 143, 0.2)
  );
  animation: rotate 3s linear infinite;
}

/* Processing/Waiting state */
.mic-visualizer[data-status="processing"]::before,
.mic-visualizer[data-status="transcribing"]::before {
  opacity: 1;
  background: conic-gradient(
    from 0deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.4),
    rgba(255, 255, 255, 0.1)
  );
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Inner glow effect */
.mic-visualizer::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: radial-gradient(
    circle at center,
    transparent 30%,
    rgba(255, 255, 255, 0.1) 70%,
    transparent 100%
  );
  z-index: 1;
  pointer-events: none;
}

/* Remove old wave animations */
.voice-wave-1,
.voice-wave-2,
.voice-wave-3,
.voice-wave-4 {
  display: none;
}

/* Status-specific inner glow colors */
.mic-visualizer.listening::after {
  background: radial-gradient(
    circle at center,
    rgba(233, 196, 106, 0.2) 30%,
    transparent 70%
  );
}

.mic-visualizer.playing::after {
  background: radial-gradient(
    circle at center,
    rgba(42, 157, 143, 0.2) 30%,
    transparent 70%
  );
}

.mic-visualizer[data-status="processing"]::after,
.mic-visualizer[data-status="transcribing"]::after {
  background: radial-gradient(
    circle at center,
    rgba(255, 255, 255, 0.1) 30%,
    transparent 70%
  );
}

/* Animation: Glow shimmer */
@keyframes shimmerGlow {
  0% {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.15);
  }
  100% {
    filter: brightness(1);
  }
}

/* Animation: Slow floating pulse */
@keyframes floatWave {
  0% {
    transform: scale(1);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.2;
  }
  100% {
    transform: scale(1);
    opacity: 0.4;
  }
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .audio-box {
    padding: 32px 20px;
  }

  .audio-box h2 {
    font-size: 1.5rem;
  }

  .mic-visualizer {
    width: 140px;
    height: 140px;
  }

  .mic-visualizer img {
    padding: 16px;
  }

  .status-message {
    font-size: 1rem;
    min-width: 200px;
    padding: 10px 20px;
  }
}
  `, "",{"version":3,"sources":["webpack://./src/chat/AudioInterface/AudioInterface.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;;;GAGC;EACD,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB;;sCAEoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;GAIC;EACD,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;GAIC;EACD,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,0CAA0C;EAC1C,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE;;;GAGC;EACD,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;;EAEE;;;GAGC;EACD,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE;;;GAGC;EACD,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,iDAAiD;AACnD;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB;;;;;GAKC;EACD,oCAAoC;EACpC,UAAU;EACV,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV;;;;;GAKC;EACD,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV;;;;;GAKC;EACD,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;;EAEE,UAAU;EACV;;;;;GAKC;EACD,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB;;;;;GAKC;EACD,UAAU;EACV,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;;;;EAIE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;;EAEE;;;;GAIC;AACH;;AAEA,4BAA4B;AAC5B;EACE;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".audio-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(38, 70, 83, 0.85);\n  backdrop-filter: blur(20px) saturate(180%);\n  -webkit-backdrop-filter: blur(20px) saturate(180%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.audio-box {\n  background: linear-gradient(135deg, \n    rgba(255, 255, 255, 0.1), \n    rgba(255, 255, 255, 0.05)\n  );\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 24px;\n  padding: 40px;\n  text-align: center;\n  max-width: 480px;\n  width: 90%;\n  position: relative;\n  box-shadow: \n    0 8px 32px 0 rgba(31, 38, 135, 0.37),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  animation: fadeInScale 0.3s ease;\n  overflow: hidden;\n}\n\n.audio-box::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(\n    circle at top right,\n    rgba(233, 196, 106, 0.15),\n    transparent 70%\n  );\n  z-index: 0;\n  pointer-events: none;\n}\n\n.audio-box::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(\n    circle at bottom left,\n    rgba(42, 157, 143, 0.15),\n    transparent 70%\n  );\n  z-index: 0;\n  pointer-events: none;\n}\n\n@keyframes fadeInScale {\n  0% {\n    opacity: 0;\n    transform: scale(0.95) translateY(10px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.close-btn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: var(--text-light);\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: rotate(90deg);\n}\n\n.audio-box h2 {\n  font-size: 1.8rem;\n  color: var(--text-light);\n  margin-bottom: 32px;\n  font-weight: 600;\n  position: relative;\n  z-index: 1;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.audio-box h2::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(to right, var(--secondary-color), var(--secondary-light));\n  border-radius: 3px;\n}\n\n.mic-circle {\n  width: 90px;\n  height: 90px;\n  background-color: var(--secondary-color);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto 16px auto;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  transition: transform 0.2s ease, background-color 0.2s ease;\n}\n\n.mic-circle:hover {\n  background-color: var(--secondary-dark);\n  transform: scale(1.05);\n}\n\n.mic-circle.recording {\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(233, 196, 106, 0.6);\n  }\n  70% {\n    box-shadow: 0 0 0 15px rgba(233, 196, 106, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(233, 196, 106, 0);\n  }\n}\n\n.mic-icon {\n  display: none;\n}\n\n.listening .mic-icon {\n  color: #ff4b4b;\n}\n\n.playing .mic-icon {\n  color: #4bff4b;\n}\n\n.audio-box p {\n  font-size: 1rem;\n  color: var(--text-dark);\n  margin-bottom: 20px;\n}\n\n.status-message {\n  color: var(--text-light);\n  margin-top: 24px;\n  font-size: 1.1rem;\n  padding: 12px 24px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: inline-block;\n  min-width: 240px;\n  position: relative;\n  z-index: 1;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.status-message[data-status=\"recording\"] {\n  background: linear-gradient(to right,\n    rgba(233, 196, 106, 0.2),\n    rgba(233, 196, 106, 0.1)\n  );\n  border-left: 3px solid var(--secondary-color);\n  animation: glowPulse 2s infinite;\n}\n\n.status-message[data-status=\"transcribing\"],\n.status-message[data-status=\"processing\"] {\n  background: linear-gradient(to right,\n    rgba(42, 157, 143, 0.2),\n    rgba(42, 157, 143, 0.1)\n  );\n  border-left: 3px solid var(--primary-color);\n  animation: glowPulse 2s infinite;\n}\n\n.status-message[data-status=\"playing\"] {\n  background: linear-gradient(to right,\n    rgba(38, 70, 83, 0.2),\n    rgba(38, 70, 83, 0.1)\n  );\n  border-left: 3px solid var(--text-light);\n  animation: glowPulse 2s infinite;\n}\n\n@keyframes glowPulse {\n  0% {\n    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);\n  }\n  50% {\n    box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);\n  }\n  100% {\n    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);\n  }\n}\n\n.submit-btn {\n  background-color: #4CAF50;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.submit-btn:hover {\n  background-color: #45a049;\n}\n\n.submit-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.mic-visualizer {\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin: 0 auto 32px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  z-index: 1;\n  overflow: hidden;\n}\n\n.mic-visualizer img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 20px;\n  position: relative;\n  z-index: 2;\n  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));\n}\n\n/* Glow ring indicator */\n.mic-visualizer::before {\n  content: '';\n  position: absolute;\n  inset: -2px;\n  border-radius: 50%;\n  background: conic-gradient(\n    from 0deg,\n    rgba(255, 255, 255, 0.1),\n    rgba(233, 196, 106, 0.3),\n    rgba(255, 255, 255, 0.1)\n  );\n  animation: rotate 4s linear infinite;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n/* Hover state */\n.mic-visualizer:hover::before {\n  opacity: 1;\n}\n\n/* User speaking state */\n.mic-visualizer.listening::before {\n  opacity: 1;\n  background: conic-gradient(\n    from 0deg,\n    rgba(233, 196, 106, 0.2),\n    rgba(233, 196, 106, 0.6),\n    rgba(233, 196, 106, 0.2)\n  );\n  animation: rotate 2s linear infinite;\n}\n\n/* Assistant speaking state */\n.mic-visualizer.playing::before {\n  opacity: 1;\n  background: conic-gradient(\n    from 0deg,\n    rgba(42, 157, 143, 0.2),\n    rgba(42, 157, 143, 0.6),\n    rgba(42, 157, 143, 0.2)\n  );\n  animation: rotate 3s linear infinite;\n}\n\n/* Processing/Waiting state */\n.mic-visualizer[data-status=\"processing\"]::before,\n.mic-visualizer[data-status=\"transcribing\"]::before {\n  opacity: 1;\n  background: conic-gradient(\n    from 0deg,\n    rgba(255, 255, 255, 0.1),\n    rgba(255, 255, 255, 0.4),\n    rgba(255, 255, 255, 0.1)\n  );\n  animation: rotate 1.5s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Inner glow effect */\n.mic-visualizer::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: radial-gradient(\n    circle at center,\n    transparent 30%,\n    rgba(255, 255, 255, 0.1) 70%,\n    transparent 100%\n  );\n  z-index: 1;\n  pointer-events: none;\n}\n\n/* Remove old wave animations */\n.voice-wave-1,\n.voice-wave-2,\n.voice-wave-3,\n.voice-wave-4 {\n  display: none;\n}\n\n/* Status-specific inner glow colors */\n.mic-visualizer.listening::after {\n  background: radial-gradient(\n    circle at center,\n    rgba(233, 196, 106, 0.2) 30%,\n    transparent 70%\n  );\n}\n\n.mic-visualizer.playing::after {\n  background: radial-gradient(\n    circle at center,\n    rgba(42, 157, 143, 0.2) 30%,\n    transparent 70%\n  );\n}\n\n.mic-visualizer[data-status=\"processing\"]::after,\n.mic-visualizer[data-status=\"transcribing\"]::after {\n  background: radial-gradient(\n    circle at center,\n    rgba(255, 255, 255, 0.1) 30%,\n    transparent 70%\n  );\n}\n\n/* Animation: Glow shimmer */\n@keyframes shimmerGlow {\n  0% {\n    filter: brightness(1);\n  }\n  50% {\n    filter: brightness(1.15);\n  }\n  100% {\n    filter: brightness(1);\n  }\n}\n\n/* Animation: Slow floating pulse */\n@keyframes floatWave {\n  0% {\n    transform: scale(1);\n    opacity: 0.4;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0.2;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0.4;\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .audio-box {\n    padding: 32px 20px;\n  }\n\n  .audio-box h2 {\n    font-size: 1.5rem;\n  }\n\n  .mic-visualizer {\n    width: 140px;\n    height: 140px;\n  }\n\n  .mic-visualizer img {\n    padding: 16px;\n  }\n\n  .status-message {\n    font-size: 1rem;\n    min-width: 200px;\n    padding: 10px 20px;\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
